import React from 'react';
import { ScreenProps } from 'src/containers/QuizContainer/types';
import { Typography } from '@guildeducationinc/recess';
import { Footer } from 'src/components/Quiz/Footer';
import { useQuiz } from '@src/components/Providers/QuizProvider';
import styles from './FeelingFeedback.module.scss';

export const FeelingFeedback: React.FC<ScreenProps> = props => {
	const { answers } = useQuiz();
	const { nextScreen, previousScreen } = props;
	const feeling = answers.feeling;

	if (feeling && feeling.toLowerCase() === 'excited') {
		return (
			<div className='margin--top_72' data-testid='feeling-feedback'>
				<Typography className={styles.primaryHeader} variant='h1'>
					We&apos;re excited too! Our support team is here to help you every step of the way.
				</Typography>
				<Footer onClickNext={nextScreen} onClickPrevious={previousScreen} />
			</div>
		);
	} else {
		return (
			<div className='margin--top_72' data-testid='feeling-feedback'>
				<Typography className={styles.primaryHeader} variant='h1'>
					We get it - it&apos;s a big decision.
				</Typography>
				<Typography className={styles.fadeIn} variant='h1'>
					Our support team is here to help you feel confident in taking the next step.
				</Typography>
				<Footer onClickNext={nextScreen} onClickPrevious={previousScreen} />
			</div>
		);
	}
};
